module.exports = __webpack_public_path__ + "static/img/bgl2l.3010553.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vr/thumbnail/bgl2l.jpg
// module id = Nx8f
// module chunks = 2